import { compose, getContext, withProps } from 'recompose'

import { CONTEXT } from '../../../../shared/Wizard/WizardProvider'

const stringifyAnswer = value => JSON.stringify(value).replace(/[{}]/g, '')

const HomeFactsStepContainer = compose(
  getContext(CONTEXT),
  withProps(({ goForward, goBack, addHomeAnswer, setProgress }) => ({
    onBeds: (beds, isDirty) => {
      isDirty && addHomeAnswer({ question: 'fact:bedrooms', answer: beds })
      setProgress(40)
      goForward()
    },
    onBaths: (baths, isDirty) => {
      const bathString = stringifyAnswer(baths)
      isDirty &&
        addHomeAnswer({ question: 'fact:bathrooms', answer: bathString })
      setProgress(60)
      goForward()
    },
    onSqFt: (sqFt, isDirty) => {
      isDirty && addHomeAnswer({ question: 'fact:finishedSqFt', answer: sqFt })
      setProgress(80)
      goForward()
    },
    onAdditionalUpdates: (updates, isDirty) => {
      const updatesString = stringifyAnswer(updates)
      isDirty &&
        addHomeAnswer({
          question: 'fact:additionalUpdates',
          answer: updatesString,
        })
      setProgress(100)
    },
    onBack: progress => {
      setProgress(progress)
      goBack()
    },
  }))
)

export default HomeFactsStepContainer
